import { PieChartGeneral } from "../../../../components/Graphics/PieChartGeneral";
import { truncateFloat } from "../../../../helpers/generalHelper";
import CardProjectFiche, { AreasVisualInfo } from "./CardProjectFiche";


const DetailGraph = ({ size, graphArea = [] }) => {
    return (
        <CardProjectFiche
            title="Graficas de Horas"
            className="h-full"
            buttonExtra={
                <div className="h-full flex justify-center items-center bg-[#ACF6EC] rounded-full px-4">
                    <p className="text-[10px]">{size}</p>
                </div>
            }
        >
            <div className="h-full w-full">
                <div className={"h-[288px] md:h-[350px] xl:h-[320px] w-full"}>
                    <PieChartGeneral
                        className={"h-full w-full"}
                        pieChartProps={{
                            margin: { top: 20, right: 40, bottom: 20, left: 40 },
                            data: graphArea,
                            enableArcLinkLabels: false,
                            activeOuterRadiusOffset: 8,
                            innerRadius: 0.5,
                            layers: [
                                "arcs",
                                "arcLabels",
                                "arcLinkLabels",
                                "legends",
                                ({ dataWithArc, centerX, centerY }) => {
                                    let total = 0;
                                    dataWithArc.forEach((datum) => {
                                        total += datum.value;
                                    });

                                    return (
                                        <text
                                            x={centerX}
                                            y={centerY}
                                            textAnchor="middle"
                                            dominantBaseline="central"
                                            className="text-[20px] font-bold"
                                        >
                                            {truncateFloat(total)}
                                        </text>
                                    );
                                },
                            ],
                        }}
                    />
                </div>
                <div className="w-full h-[calc(100%-288px)] md:h-[calc(100%-350px)] xl:h-[calc(100%-320px)] px-11 flex flex-wrap justify-center items-center gap-1 overflow-hidden">
                    {graphArea.map((pieData, index) => (
                        <AreasVisualInfo key={`${index}-info-pie`} {...pieData} />
                    ))}
                </div>
            </div>
        </CardProjectFiche>
    );
};

export default DetailGraph;
